/**
 * Returns a Formmated Units Value
 * @param {Units} units - the units to be formatted
 * @param {string} [unitToBeReturned] - optional unit to format
 * @param {number} [conversionRate] - optional conversion rate value
 * @return {string} - the formatted unit value
 */
const formatUnitsValue = (units, unitToBeReturned, conversionRate) => {
    let currentValue = units.getValue();

    if (unitToBeReturned && conversionRate) {
        currentValue = convertUnits(currentValue, unitToBeReturned, conversionRate);
    }

    currentValue = getDigitsFormat(currentValue);

    return `${currentValue} ${unitToBeReturned || units.unitLabel}`;
};

/**
 * Returns the converted value of a units value
 * @param {number} value - the units value to be formatted
 * @param {string} unitToConvert - unit to format
 * @param {number} conversionRate - conversion rate value
 * @param {number} multiplier - multiplier used to avoid JS miscalculations
 * @return {string} - the formatted unit value
 */
const convertUnits = (value, unitToConvert, conversionRate, multiplier) => {
    if (unitToConvert === "kg") {
        const finalValue = ((value * multiplier) * conversionRate) / multiplier;
        return parseFloat(finalValue);
    }

    var resultConversion = Math.round(value / conversionRate);

    return value > 0 && resultConversion == 0 ? 1 : resultConversion;
};

/**
 * Returns the value fixing the decimals
 * @param {number} val - the input value to be fixed
 * @param {string} unit - unit to format
 * @return {number} - the fixed value
 */
const getFixedValue = (val, unit) => {
    const newValue = (val.indexOf(" ") >= 0) ? val.split(" ")[0] : val;
    const replacedValue = newValue.replace(",", ".");

    if (unit === "kg") {
        return parseFloat(replacedValue);
    }

    return (0 < parseFloat(replacedValue) && parseFloat(replacedValue) < 1) ? 1 : parseFloat(replacedValue);
};

/**
 * Returns the correct step value
 * @param {number} val - value to be checked with the step
 * @param {number} step - the step to be used as base
 * @param {number} multiplier - multiplier used to avoid JS miscalculations
 * @return {number} - the correct step value
 */
const getStepValue = (val, step, multiplier) => {
    const stepDiv = (val * multiplier) / (step * multiplier);

    if (stepDiv % 1 !== 0) {
        return ((step * multiplier) * Math.round(stepDiv)) / multiplier;
    }

    return val;
};

/**
 * Returns real/closest max possible allocation to sell.
 * Example
 * Minimum Order Quantity: 3.20
 * Step Quantity: 1.60
 * Inventory allocation: 30
 * customer can order only 28.8 max. 3.20 + 1.6 + ... + 1.6 = 28.8 and can't order more than 30, because next step will be 30.4 (30.4 = 28.8 + 1.6) and 30.4 is greater than inventory allocation.
 *
 * @param {number} qty - the quantity value to be updated
 * @param {number} stepQuantity - product step quantity
 * @return {number} - the real/closest max possible allocation to sell
 * */
const getClosestMaxAllocation = (qty, stepQuantity) => {
    let division = removeTrailingDigits(qty / stepQuantity);
    return Math.round((Math.floor(division) * stepQuantity) * 1000) / 1000;
};

// Helper function
/**
 * Returns a Formmated value based on the number digits
 * @param {number} val - the number to be formatted
 * @return {string} - the formatted number value
 */
const getDigitsFormat = val => {
    return (val % 1 != 0) ? val.toFixed(2).replace(".", ",") : parseInt(val, 10);
};

/**
 * Removes extra digits after comma.
 * 3.2+1.6 = 4.80000000001 -> 4.8
 * @param {number} quantity - quantity to fix
 *
 * @return {number} - quantity fixed
 */
const removeTrailingDigits = quantity => {
    return Math.round((quantity) * 1000) / 1000;
};

module.exports = {
    formatUnitsValue,
    convertUnits,
    getFixedValue,
    getStepValue,
    getClosestMaxAllocation
};
